import * as React from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'redux-first-history';
import styled from 'styled-components';
import { spacing, colors } from 'ui/theme';
import { FullWidth } from 'ui/utility/fullWidth';
import { pxToRem } from 'utils/convert';
import { WorkflowWebhookHeader } from './WorkflowWebhookHeader';
import { WorkflowWebhookEditor } from './WorkflowWebhookEditor';

import { NEW_WEBHOOK } from '../constants';
import type { WorkflowWebhook } from '../types';

import { EditMode } from '../types';

const Content = styled(FullWidth)`
  background-color: ${colors.grey1};
  padding: ${spacing.x4} ${pxToRem(40)};
`;

export const Panel = styled.div`
  background-color: ${colors.white};
  border: 1px solid ${colors.grey15};
  border-radius: ${spacing.quarter};
  padding: ${spacing.x3} ${spacing.double} ${spacing.double};
  margin: 0 auto;
  width: ${pxToRem(870)};
`;

export const CreateWorkflowWebhookPage = () => {
  const [webhook, setWebhook] = React.useState<WorkflowWebhook>(NEW_WEBHOOK);
  const dispatch = useDispatch();

  const onSave = () => {
    dispatch(push(`/workflows/webhooks`));
  };

  return (
    <div>
      <WorkflowWebhookHeader workflowWebhook={NEW_WEBHOOK} />
      <Content>
        <Panel>
          <WorkflowWebhookEditor
            mode={EditMode.Create}
            webhook={webhook}
            onUpdate={setWebhook}
            onSave={onSave}
          />
        </Panel>
      </Content>
    </div>
  );
};
